<template>
    <div>
        <div class="wrapper">
            <el-button class="item" size="mini" @click="flowLine" type="primary">流动线</el-button>
            <el-button class="item" size="mini" @click="drawWall" type="primary">动态立体墙</el-button>
            <el-button class="item" size="mini" @click="drawWall2" type="primary">动态立体墙2</el-button>
            <el-button class="item" size="mini" @click="DiffusionCircle" type="primary">扩散圆</el-button>
            <el-button class="item" size="mini" @click="DiffusionCircleA" type="primary">扩散圆2</el-button>
            <el-button class="item" size="mini" @click="DiffusionCircleB" type="primary">扩散圆3</el-button>
            <el-button class="item" size="mini" @click="RadarScan" type="primary">雷达扫描</el-button>
            <el-button class="item" size="mini" @click="PathAnimation" type="primary">轨迹回放</el-button>
            <el-button class="item" size="mini" @click="DynamicWater" type="primary">动态水面</el-button>
            <el-button class="item" size="mini" @click="ElectricArc" type="primary">电光弧圈</el-button>
            <el-button class="item" size="mini" @click="ViewRectangle" type="primary">查看当前视角范围</el-button>
            <el-button class="item" size="mini" @click="realRun" type="primary">实时漫游</el-button>
            <el-button class="item" size="mini" @click="rectangularSensor" type="primary">相控雷达扫描</el-button>
            <el-button class="item" size="mini" @click="video" type="primary">语音发送</el-button>
            <el-button class="item" size="mini" @click="radarSolidScan" type="primary">立体雷达扫描</el-button>
            <el-button class="item" size="mini" @click="drawHexagonPloygon" type="primary">贴地图元</el-button>
        </div>
        <div class="wrapper">
            <el-button class="item" size="mini" @click="drawSnow" type="primary">雪</el-button>
            <el-button class="item" size="mini" @click="drawRain" type="primary">雨</el-button>
            <el-button class="item" size="mini" @click="drawFog" type="primary">雾</el-button>
            <el-button class="item" size="mini" @click="drawOpticalBand" type="primary">建筑光带</el-button>
            <el-button class="item" size="mini" @click="drawlightModel" type="primary">局部光源</el-button>
        </div>
        <div class="bottom-div">
            <!-- <el-button size="mini" @click="clear()" type="primary">清除</el-button> -->
        </div>
    </div>
</template>
  
<script>
import AnalysisManage from "@/utils/cesiumBD/analysis/AnalysisManage.js";
import CrossSection from "@/utils/cesiumBD/analysis/CrossSection.js";
let analysisUti = undefined;
let crossSectionUti = undefined
import CrossSectionCom from "../CrossSection/index.vue"
import PathAnimation from "@/utils/cesiumBD/animation/PathAnimation"
import RealAnimation from "@/utils/cesiumBD/animation/RealAnimation"
import radarSolidScan from "@/utils/cesiumBD/effect/entity/radarSolidScan"
import {drawHexagon}  from "@/utils/cesiumBD/primitive/Ploygon"
import Snow from "@/utils/cesiumBD/postProcessStages/Snow"
import Rain from "@/utils/cesiumBD/postProcessStages/Rain"
import Fog from "@/utils/cesiumBD/postProcessStages/Fog"
import {opticalBand ,lightModel }  from "@/utils/cesiumBD/primitive/Tileset"
export default {
    methods: {
        drawlightModel(){
            lightModel();
        },
        drawOpticalBand(){
            opticalBand();
        },
        drawFog(){
            new Fog().add();
        },
        drawRain(){
            new Rain().add();
        },
        drawSnow(){
            new Snow().add();
        },
        drawHexagonPloygon(){
            drawHexagon();
        },
        radarSolidScan() {
            new radarSolidScan({
                viewer: viewer,
                position: [113.9236839, 22.528061],
                radius: 1000.0,
                color: new Cesium.Color(1.0, 1.0, 0.0, 0.3),
                speed: 5.0
            })
        },
        video() {
            navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
                const mediaRecorder = new MediaRecorder(stream);
                const chunks = [];

                mediaRecorder.addEventListener('dataavailable', (event) => {
                    chunks.push(event.data);
                });

                mediaRecorder.addEventListener('stop', () => {
                    const blob = new Blob(chunks, { type: 'audio/ogg; codecs=opus' });

                    alert()
                });

                // 开始录制
                mediaRecorder.start();

                // 录制10秒后停止
                setTimeout(() => {
                    mediaRecorder.stop();
                }, 10000);
            }).catch((error) => {
                console.error('无法录制音频', error);
            });

        },
        rectangularSensor() {
            let r = new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(90),
                Cesium.Math.toRadians(0),
                Cesium.Math.toRadians(0));
            let l = Cesium.Cartesian3.fromDegrees(117.224, 31.819, 128);
            let sensorEntity = viewer.entities.add({
                position: l,
                orientation: Cesium.Transforms.headingPitchRollQuaternion(l, r),
                rectangularSensor: new Cesium.RectangularSensorGraphics({
                    radius: 100000,
                    xHalfAngle: Cesium.Math.toRadians(45),
                    yHalfAngle: Cesium.Math.toRadians(45),
                    material: new Cesium.Color(1.0, 0.0, 1.0, 0.4),
                    lineColor: new Cesium.Color(1.0, 0.0, 1.0, 1.0),
                    intersectionColor: new Cesium.Color(1.0, 0.0, 1.0, 0.4),
                    showScanPlane: true,
                    scanPlaneColor: new Cesium.Color(1.0, 0.0, 1.0, 1.0),
                    scanPlaneMode: "vertical",
                    scanPlaneRate: 3,
                    showThroughEllipsoid: !1
                })
            })

            // setTimeout(() => {
            //     viewer.entities.remove(sensorEntity);
            // }, 5000);
        },
        realRun() {
            var pre = new Date()

            var entity = this.createBillboardEntity({}, []);
            DBentityCollection.add(entity);

            var animation = new RealAnimation({
                entity: entity,
                multiple: 10
            });

            var entity2 = this.createBillboardEntity({}, []);
            DBentityCollection.add(entity2);

            var animation2 = new RealAnimation({
                entity: entity2,
                multiple: 10
            });


            var entity3 = this.createBillboardEntity({}, []);
            DBentityCollection.add(entity3);

            var animation3 = new RealAnimation({
                entity: entity3,
                multiple: 10
            });

            var entity4 = this.createBillboardEntity({}, []);
            DBentityCollection.add(entity4);

            var animation4 = new RealAnimation({
                entity: entity4,
                multiple: 10
            });

            let diff = 0.1;
            let lon = 111;
            let lat = 33;

            let lon2 = 111;
            let lat2 = 33;

            let lon3 = 111;
            let lat3 = 33;


            let lon4 = 111;
            let lat4 = 33;

            setInterval(() => {
                if (pre) {

                    var diffInSeconds = (new Date() - pre) / 1000;
                    console.log(diffInSeconds)

                    pre = new Date();

                    lon += diff;
                    lat += diff;
                    var p = new Cesium.Cartesian3(lon, lat, 100.0);
                    animation.update(p, new Date());

                    lon2 -= diff;
                    lat2 -= diff;
                    var p2 = new Cesium.Cartesian3(lon2, lat2, 100.0);
                    animation2.update(p2, new Date());

                    lon3 -= diff;
                    var p3 = new Cesium.Cartesian3(lon3, lat3, 100.0);
                    animation3.update(p3, new Date());


                    var p4 = new Cesium.Cartesian3(lon4, lat4, 100.0);
                    animation4.update(p4, new Date());


                }

            }, 1000)
        },
        ViewRectangle() {
            var res = viewer.scene.camera.computeViewRectangle();
            alert(JSON.stringify(res));
        },
        ElectricArc() {
            var ellipsoid = viewer.entities.add({
                name: "Dome",
                position: Cesium.Cartesian3.fromDegrees(-120.0, 40.0),
                ellipsoid: {
                    radii: new Cesium.Cartesian3(200000.0, 200000.0, 200000.0),
                    maximumCone: Cesium.Math.PI_OVER_TWO,
                    material: new Cesium.ElectricArcMaterialProperty({
                        color: Cesium.Color.ROYALBLUE,
                        speed: 5
                    }),
                    outline: false,
                },
            });
            viewer.flyTo(ellipsoid);
        },
        RadarScan() {
            var cylinder = this.createcylinder(new Cesium.RadarRadiationWaveMaterialProperty(
                {
                    color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                    repeat: 15,
                    offset: 0,
                    thickness: 0.3,
                    duration: 3000,
                }
            ));
            DBentityCollection.add(cylinder);
            viewer.flyTo(cylinder);
        },

        createcylinder(material) {
            // 圆锥
            const entity = new Cesium.Entity({
                position: Cesium.Cartesian3.fromDegrees(104.07, 30.66),
                cylinder: {
                    length: 300.0, //圆锥高度
                    topRadius: 0.0, //顶部半径
                    bottomRadius: 100.0, //底部半径
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                    material: material, //
                },
            });

            return entity;
        },


        PathAnimation() {
            var data = {"keyPos":[{"x":-1835529.3457677886,"y":5065242.30728649,"z":3403561.191707534},{"x":-1967104.6061032107,"y":5227981.040915475,"z":3069295.225437249},{"x":-2304470.376500031,"y":5089146.418845423,"z":3067474.131091282},{"x":-2779514.455259066,"y":4858204.923527609,"z":3049722.6424783138},{"x":-2692810.174740772,"y":4427400.2983088195,"z":3704867.35253569},{"x":-2302907.87861797,"y":4660084.49963633,"z":3682648.4754867353},{"x":-2414428.853920473,"y":4999308.498728163,"z":3131478.7625410436},{"x":-2734663.006866156,"y":4841075.334442439,"z":3115879.9997001737},{"x":-2656401.0301605826,"y":4499369.27237989,"z":3645188.581699402},{"x":-1865861.5414092042,"y":4904670.094173418,"z":3613729.903993162},{"x":-2050412.7956839213,"y":5162924.886459766,"z":3123775.522053137},{"x":-2730074.134468578,"y":4853505.51454406,"z":3101606.605477318}],"cart":{"x":-2334259.448787576,"y":4868926.643984264,"z":3383528.073777126}};
            var positions = data.keyPos;
            var p = positions[0];
            var entity = this.createGLBElement(p, 'data/mx/dajiang.gltf');
            DBentityCollection.add(entity);
            viewer.flyTo(entity);
            var animation = new PathAnimation({
                entity: entity,
                positions: positions,
                speed: 100,
                multiple: 15,
                height: 10000
            });

            animation.start();

        },

        //构建glb模型
        createGLBElement(position, uri) {
            var glb = {
                position: position, //模型的加载位置,
                model: {
                    uri: uri, //模型的地址 
                    scale: 5000, //模型缩放比例
                    maximumScale: 20000, // 模型的最大比例尺大小。 minimumPixelSize的上限
                    incrementallyLoadTextures: true, // 加载模型后纹理是否可以继续流入
                    runAnimations: true, // 是否应启动模型中指定的glTF动画
                    clampAnimations: true, // 指定glTF动画是否应在没有关键帧的持续时间内保持最后一个姿势
                    shadows: Cesium.ShadowMode.ENABLED,
                    heightReference: Cesium.HeightReference.NONE //设置模型贴地,
                }
            }

            return new Cesium.Entity(glb);
        },
        createBillboardEntity(center, positions) {
            const entity = new Cesium.Entity({
                position: center,
                billboard: {
                    image: "data/img/marker/mark2.png",
                    scale: 1.0,
                    horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                    verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                    heightReference: Cesium.HeightReference.NONE,
                },
                polyline: {
                    positions: positions,
                    width: 10,
                    material: new Cesium.PolylineArrowMaterialProperty(Cesium.Color.PURPLE),
                    // material: new Cesium.PolylineTrailLinkMaterialProperty(
                    //     {
                    //         color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                    //         duration: 4000
                    //     }
                    // ),
                    clampToGround: true,
                },
            });
            return entity;
        },

        flowLine() {

            var data = { "keyPos": [{ "x": -1278319.3279293242, "y": 5291156.886878176, "z": 3313037.2641520854 }, { "x": -1278311.063311217, "y": 5291153.8290171055, "z": 3313045.282575491 }, { "x": -1278301.6098004219, "y": 5291149.94726093, "z": 3313055.063607726 }, { "x": -1278295.6034485318, "y": 5291150.421949577, "z": 3313056.6125334473 }, { "x": -1278286.965493198, "y": 5291155.218884689, "z": 3313052.3133286303 }, { "x": -1278286.505452014, "y": 5291157.770829863, "z": 3313048.441301488 }, { "x": -1278285.8554335204, "y": 5291162.409154712, "z": 3313041.332288894 }, { "x": -1278284.0083844285, "y": 5291163.307047288, "z": 3313040.6157742655 }, { "x": -1278280.1564687327, "y": 5291167.527327294, "z": 3313035.3970475416 }, { "x": -1278276.7245110536, "y": 5291169.71236538, "z": 3313033.2460347414 }, { "x": -1278274.1423726405, "y": 5291171.048819277, "z": 3313032.11550604 }, { "x": -1278272.794138632, "y": 5291174.410751422, "z": 3313027.2988858754 }, { "x": -1278274.8708339361, "y": 5291178.35213498, "z": 3313020.2504119365 }, { "x": -1278276.1708241685, "y": 5291179.436906201, "z": 3313018.031313358 }, { "x": -1278279.7868371308, "y": 5291181.555072847, "z": 3313013.285214265 }, { "x": -1278284.702748594, "y": 5291183.028293656, "z": 3313009.0640537357 }, { "x": -1278293.916120787, "y": 5291184.034672851, "z": 3313003.9364444306 }, { "x": -1278303.5587755868, "y": 5291184.896221, "z": 3312998.874034762 }, { "x": -1278312.729427879, "y": 5291184.25075528, "z": 3312996.3832310624 }, { "x": -1278322.3861529108, "y": 5291182.278343374, "z": 3312995.811182207 }, { "x": -1278332.3693646707, "y": 5291179.65093794, "z": 3312996.1530574607 }, { "x": -1278340.0282610701, "y": 5291177.372673052, "z": 3312996.8318705014 }, { "x": -1278349.9662900458, "y": 5291174.896214079, "z": 3312996.9515443016 }, { "x": -1278351.4829963264, "y": 5291175.6742500365, "z": 3312995.135946399 }, { "x": -1278358.3509431442, "y": 5291175.996019247, "z": 3312991.993157574 }, { "x": -1278365.7988124192, "y": 5291177.2855459675, "z": 3312987.0928182057 }, { "x": -1278375.3915651399, "y": 5291175.758795896, "z": 3312985.8381272075 }, { "x": -1278379.9992381476, "y": 5291174.653748394, "z": 3312985.8251309893 }, { "x": -1278361.331084398, "y": 5291172.802442484, "z": 3312995.917240236 }, { "x": -1278353.2768760868, "y": 5291170.065383339, "z": 3313003.3463171627 }, { "x": -1278350.637483277, "y": 5291170.865586118, "z": 3313003.0884907893 }, { "x": -1278346.1181250708, "y": 5291171.166055264, "z": 3313004.343982289 }, { "x": -1278343.6989564213, "y": 5291168.574009814, "z": 3313009.383201861 }, { "x": -1278338.9120610524, "y": 5291166.586410585, "z": 3313014.371001344 }, { "x": -1278338.048657912, "y": 5291164.958340564, "z": 3313017.2846768624 }, { "x": -1278332.566525085, "y": 5291162.651489998, "z": 3313023.045373111 }, { "x": -1278331.3756949406, "y": 5291159.847968168, "z": 3313027.9492496317 }, { "x": -1278327.766949972, "y": 5291158.0787597485, "z": 3313032.139003043 }], "cart": { "x": -1278324.2876089662, "y": 5291165.802988201, "z": 3313021.218902033 } }
            var line = this.createPolyline(data.keyPos, new Cesium.PolylineTrailLinkMaterialProperty(
                {
                    color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                    duration: 3000
                }
            ));
            viewer.flyTo(line);
        },
        drawWall2() {
            var wall = viewer.entities.add({
                name: "立体墙效果",
                wall: {
                    positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                        118.286419, 31.864436, 20000.0,
                        119.386419, 31.864436, 20000.0,
                        119.386419, 32.864436, 20000.0,
                        118.286419, 32.864436, 20000.0,
                        118.286419, 31.864436, 20000.0,
                    ]),
                    // 设置高度
                    maximumHeights: new Array(5).fill(10000),
                    minimumHeights: new Array(5).fill(1000),
                    material: new Cesium.StandardWallMaterialProperty({
                        color: new Cesium.Color(1.0, 1.0, 0.0, 1.0),
                        duration: 2000,
                        count: 100
                    }),
                }
            });

            viewer.flyTo(wall);
        },
        drawWall() {
            // 绘制墙体
            var wall = viewer.entities.add({
                name: "立体墙效果",
                wall: {
                    positions: Cesium.Cartesian3.fromDegreesArrayHeights([
                        118.286419, 31.864436, 20000.0,
                        119.386419, 31.864436, 20000.0,
                        119.386419, 32.864436, 20000.0,
                        118.286419, 32.864436, 20000.0,
                        118.286419, 31.864436, 20000.0,
                    ]),
                    // 设置高度
                    maximumHeights: new Array(5).fill(10000),
                    minimumHeights: new Array(5).fill(1000),
                    material: new Cesium.DynamicWallMaterialProperty({
                        color: new Cesium.Color(1.0, 1.0, 0.0, 0.5),
                        duration: 3000
                    }),
                }
            });

            viewer.flyTo(wall);
        },
        DiffusionCircleB() {
            var material = new Cesium.DynamicCircleBMaterialProperty({
                color: new Cesium.Color(1.0, 1.0, 0.0, 1),
                time: 2,
                count: 4,
                gradient: 0.2
            });

            var ellipse = this.createClircle(material);
            viewer.flyTo(ellipse);
        },
        DiffusionCircleA() {
            var material = new Cesium.DynamicCircleAMaterialProperty({
                color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                time: 2
            });

            var ellipse = this.createClircle(material);
            viewer.flyTo(ellipse);
        },
        DiffusionCircle() {
            var material = new Cesium.DiffusionCircleMaterialProperty({
                color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                duration: 3000
            });

            var ellipse = this.createClircle(material);
            viewer.flyTo(ellipse);
        },
        DynamicWater() {
            var data = { "keyPos": [{ "x": -2725788.9906113422, "y": 4716522.779469187, "z": 3306273.792780391 }, { "x": -2720247.800049365, "y": 4726024.590600944, "z": 3297317.277337363 }, { "x": -2720952.7934625717, "y": 4732365.918689966, "z": 3287691.2354631964 }, { "x": -2721972.7074543242, "y": 4733106.099008676, "z": 3285793.7020241185 }, { "x": -2724928.7132420135, "y": 4734464.110933287, "z": 3281413.7141975113 }, { "x": -2729417.7335457937, "y": 4736766.241118436, "z": 3274400.2749344287 }, { "x": -2734439.213248512, "y": 4736919.539854342, "z": 3270015.5356348744 }, { "x": -2739312.451540253, "y": 4736135.473586173, "z": 3267090.9169073263 }, { "x": -2744919.3533245907, "y": 4735937.19678464, "z": 3262699.017534674 }, { "x": -2753597.095109396, "y": 4733543.135151212, "z": 3258884.525099673 }, { "x": -2765574.445744051, "y": 4726268.478954318, "z": 3259297.7799479086 }, { "x": -2773661.8376220223, "y": 4718080.705394391, "z": 3264250.9809674392 }, { "x": -2776117.462745512, "y": 4713479.104455079, "z": 3268777.639732755 }, { "x": -2781098.6826032614, "y": 4709126.647319463, "z": 3270802.316814604 }, { "x": -2783404.007497001, "y": 4705216.7011324335, "z": 3274441.7605317235 }, { "x": -2779968.4319174294, "y": 4702317.661078428, "z": 3281469.8721224177 }, { "x": -2776875.851088348, "y": 4704853.3793665, "z": 3280460.367167432 }, { "x": -2772764.738607672, "y": 4711460.717831672, "z": 3274489.6414626576 }, { "x": -2766824.2415482723, "y": 4718916.784574057, "z": 3268811.283541759 }, { "x": -2764106.6650795117, "y": 4718667.828595375, "z": 3271450.9209323083 }, { "x": -2761376.2923568855, "y": 4718731.280422322, "z": 3273649.6374703697 }, { "x": -2766290.751078436, "y": 4712899.903190176, "z": 3277869.662751848 }, { "x": -2768663.6412449917, "y": 4708440.694381313, "z": 3282242.2355121705 }, { "x": -2768257.4300809167, "y": 4706011.8152410025, "z": 3286040.426536934 }, { "x": -2759280.590283875, "y": 4711674.486601393, "z": 3285479.733312781 }, { "x": -2758584.1038022446, "y": 4709108.707363502, "z": 3289711.8877793434 }, { "x": -2753647.4262580425, "y": 4708789.809336311, "z": 3294270.4032461615 }, { "x": -2750374.3161660465, "y": 4709282.779632883, "z": 3296285.8505580854 }, { "x": -2751621.6004728274, "y": 4706218.392447217, "z": 3299597.4581591967 }, { "x": -2753315.502564878, "y": 4704483.113613722, "z": 3300651.7320009135 }, { "x": -2747540.4986666422, "y": 4706332.0724287545, "z": 3302812.8816587655 }, { "x": -2741984.734535482, "y": 4708337.509254496, "z": 3304559.4469413366 }], "cart": { "x": -2751742.1432856736, "y": 4718092.52272023, "z": 3282609.9491572203 } };
            var polygon = this.createPolygon(data.keyPos, new Cesium.DynamicWaterMaterialProperty(
                {
                    color: new Cesium.Color(1.0, 0.0, 0.0, 1),
                }
            ));
            viewer.flyTo(polygon);
        },
        createClircle(material) {
            var ellipse = viewer.entities.add({
                position: Cesium.Cartesian3.fromDegrees(109.767575, 27.072926),
                ellipse: {
                    semiMajorAxis: 500.0,
                    semiMinorAxis: 500.0,
                    heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                    material: material,
                    outline: false,
                    outlineColor: Cesium.Color.RED,
                },
            });
            return ellipse;
        },
        createPolygon(hierarchy, material) {
            var polygon = viewer.entities.add({
                polygon: {
                    hierarchy: hierarchy,
                    clampToGround: true,
                    show: true,
                    fill: true,
                    material: material,
                    width: 3,
                    outlineColor: Cesium.Color.BLACK,
                    outlineWidth: 2,
                    outline: true,
                    disableDepthTestDistance: Number.MAX_VALUE,
                }
            });
            return polygon;
        },
        createPolyline(positions, material) {
            var polyline = viewer.entities.add({
                polyline: {
                    positions: positions,
                    width: 10,
                    clampToGround: true,
                    disableDepthTestDistance: Number.MAX_VALUE,
                    material: material
                },
            });
            return polyline;
        },

        crossSection() {
            if (!crossSectionUti) {
                crossSectionUti = new CrossSection({
                    canEdit: false,
                    analysisDone: (xData, yData) => {
                        console.log(xData);
                        console.log(yData);

                        this.$dialog.open({
                            title: "剖面分析",
                            area: {
                                height: "260px",
                                width: "calc(100vw - 320px)",
                            },
                            location: {
                                bottom: "16px",
                                right: "0px"
                            },
                            content: {
                                type: "vue",
                                subCom: CrossSectionCom,
                                subData: {
                                    xData: xData,
                                    yData: yData
                                }
                            },
                        });
                    }
                });
            }
            crossSectionUti.reset();
            crossSectionUti.start();
        },
        baseDraw(type) {
            if (!analysisUti) {
                analysisUti = new AnalysisManage({
                    canEdit: true,
                });
            }
            analysisUti.start(type);
            //this.test();
        },
        addTile() {
            var tileset = new Cesium.Cesium3DTileset({
                url: "http://cim.qctech.ltd/staticdata/WCOSGB/1data/tileset.json",
            });
            viewer.scene.primitives.add(tileset);
            viewer.zoomTo(tileset, new Cesium.HeadingPitchRange(0, -Math.PI / 2, 0));
        },
        //坐标点旋转测试
        test() {
            var a = Cesium.Cartesian3.fromDegrees(111, 33, 100);

            var c = Cesium.Cartesian3.fromDegrees(111, 32, 100);

            let positions = [];
            positions.push(a);
            for (var i = 0; i <= 360; i++) {
                var b = this.getRotateCenterPoint(c, positions[i], 1);
                this.createPoint(b);
                positions.push(b);
            }

            this.createPoint(a, Cesium.Color.AQUA);
            var p = this.createPoint(c, Cesium.Color.RED);
            viewer.zoomTo(p);

            // for (var i = 0; i < positions.length - 1; i++) {
            //   var angle = this.getAngleCenterPointDir(c, positions[i], positions[i + 1]);
            //   let theta = angle * (180 / Math.PI);
            //   if (theta < 0) {
            //     theta = theta + 360;
            //   }
            //  console.log(theta);
        },
        getRotatePos(pointA, pointB, angle) {
            //然后使用Transforms类中的rotate方法进行旋转，将旋转后的向量加上点A的坐标，即可得到旋转后的坐标：
            var vector = Cesium.Cartesian3.subtract(pointB, pointA, new Cesium.Cartesian3());

            var rotatedVector = Cesium.Matrix3.multiplyByVector(
                Cesium.Matrix3.fromRotationY(Cesium.Math.toRadians(angle)),
                vector,
                new Cesium.Cartesian3()
            );
            var rotatedPoint = Cesium.Cartesian3.add(
                pointA,
                rotatedVector,
                new Cesium.Cartesian3()
            );

            return rotatedPoint;
        },
        getAngleCenterPointDir(center, pointA, pointB) {
            //以点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
            const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(center);
            //求世界坐标到局部坐标的变换矩阵
            const worldToLocal_Matrix = Cesium.Matrix4.inverse(
                localToWorld_Matrix,
                new Cesium.Matrix4()
            );
            //a点在局部坐标的位置，其实就是局部坐标原点
            const localPosition_A = Cesium.Matrix4.multiplyByPoint(
                worldToLocal_Matrix,
                pointA,
                new Cesium.Cartesian3()
            );
            //B点在以A点为原点的局部的坐标位置
            const localPosition_B = Cesium.Matrix4.multiplyByPoint(
                worldToLocal_Matrix,
                pointB,
                new Cesium.Cartesian3()
            );

            //弧度
            const angle1 = Math.atan2(localPosition_A.x - 1, localPosition_A.y - 0);
            const angle2 = Math.atan2(localPosition_B.x - 1, localPosition_B.y - 0);

            const angle = angle2 - angle1;

            //角度
            //let theta = angle * (180 / Math.PI);
            // if (theta < 0) {
            //   theta = theta + 360;
            // }
            return angle;
        },
        createPoint(position, color) {
            var point = viewer.entities.add({
                position: position,
                point: {
                    pixelSize: 10,
                    color: color || Cesium.Color.YELLOW,
                },
            });
            return point;
        },

        /**
         * 计算两个点的方位角度
         */
        courseAngle(center, pointA, pointB) {
            //以点为原点建立局部坐标系（东方向为x轴,北方向为y轴,垂直于地面为z轴），得到一个局部坐标到世界坐标转换的变换矩阵
            const localToWorld_Matrix = Cesium.Transforms.eastNorthUpToFixedFrame(center);
            //求世界坐标到局部坐标的变换矩阵
            const worldToLocal_Matrix = Cesium.Matrix4.inverse(
                localToWorld_Matrix,
                new Cesium.Matrix4()
            );
            //a点在局部坐标的位置，其实就是局部坐标原点
            const localPosition_A = Cesium.Matrix4.multiplyByPoint(
                worldToLocal_Matrix,
                pointA,
                new Cesium.Cartesian3()
            );
            //B点在以A点为原点的局部的坐标位置
            const localPosition_B = Cesium.Matrix4.multiplyByPoint(
                worldToLocal_Matrix,
                pointB,
                new Cesium.Cartesian3()
            );

            //弧度
            const angle1 = Math.atan2(localPosition_A.x - 1, localPosition_A.y - 0);
            const angle2 = Math.atan2(localPosition_B.x - 1, localPosition_B.y - 0);

            const angle = angle2 - angle1;

            //角度
            let theta = angle * (180 / Math.PI);
            // if (theta < 0) {
            //   theta = theta + 360;
            // }
            return theta;
        },

        getAngleCenterPoint(center, pointA, pointB) {
            var direction1 = Cesium.Cartesian3.subtract(
                center,
                pointA,
                new Cesium.Cartesian3()
            );

            var direction2 = Cesium.Cartesian3.subtract(
                center,
                pointB,
                new Cesium.Cartesian3()
            );

            var ray1 = new Cesium.Ray(center, direction1);
            var ray2 = new Cesium.Ray(center, direction2);
            var angle = Cesium.Cartesian3.angleBetween(ray1.direction, ray2.direction);
            var angle_deg = Cesium.Math.toDegrees(angle);

            return angle_deg;
        },
        getRotateCenterPoint(center, point1, angle) {
            // 计算center的地面法向量
            var chicB = Cesium.Cartographic.fromCartesian(center);
            chicB.height = 0;
            var dB = Cesium.Cartographic.toCartesian(chicB);

            var chicC = Cesium.Cartographic.fromCartesian(center);
            chicC.height = 10;
            var dC = Cesium.Cartographic.toCartesian(chicC);

            var normaB = Cesium.Cartesian3.normalize(
                Cesium.Cartesian3.subtract(dB, dC, new Cesium.Cartesian3()),
                new Cesium.Cartesian3()
            );

            // 构造基于center的法向量旋转angle度的矩阵
            var Q = Cesium.Quaternion.fromAxisAngle(normaB, Cesium.Math.toRadians(angle));
            var m3 = Cesium.Matrix3.fromQuaternion(Q);
            var m4 = Cesium.Matrix4.fromRotationTranslation(m3);

            // 计算point1点相对center点的坐标A1
            var A1 = Cesium.Cartesian3.subtract(point1, center, new Cesium.Cartesian3());

            //对A1应用旋转矩阵
            var p = Cesium.Matrix4.multiplyByPoint(m4, A1, new Cesium.Cartesian3());
            // 新点的坐标
            var pointNew = Cesium.Cartesian3.add(p, center, new Cesium.Cartesian3());

            return pointNew;
        },
        clear() {
            analysisUti && analysisUti.clear();

            crossSectionUti && crossSectionUti.clear();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.wrapper {
    padding: 16px 16px 16px 16px;
    display: grid;
    grid-gap: 16px;
    border: solid 1px #e4e7ed;
    overflow-y: auto;
    overflow-x: hidden;
    grid-template: repeat(2, 1fr) / repeat(2, 1fr);
}

.item {
    text-align: center;
    border: solid 1px #e4e7ed;
    width: auto;
    margin-left: 0px;
}

.bottom-div {
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
  